import styled from 'styled-components';
import { Text } from '@alefeducation/ui-elements-library-core';
import React from 'react';

const StyledRoleSelectionHeader = styled.div`
  height: 62px;
  background: rgb(246, 246, 246); // Not found in the library
  box-shadow: 0px -1px 4px 0px rgba(204, 204, 204, 0.5);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  padding-left: ${({ theme }) => theme.space[28]}px;
  padding-right: ${({ theme }) => theme.space[14]}px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    font-size: 16px; // Need to add in the library.
  }
`;

const RolesSelectionHeader = () => {
  return (
    <StyledRoleSelectionHeader data-testid="role-selection-header">
      <Text variant="body-large">Roles</Text>
    </StyledRoleSelectionHeader>
  );
};

export default RolesSelectionHeader;
